import { lloFetch } from '../../../helpers/lloFetch';
import trans from '../../../helpers/trans';
import { FetchResult, FetchResultType } from '../../FetchResult';
import { EducationResource } from './Educations';

export const getCompetentNLEducationsApiCall = async (query: string): Promise<FetchResult<EducationResource[], string>> => {
    try {
        const requestConfig = new URLSearchParams({
            searchTerm: query,
            pageSize: '10',
            page: '1',
        }).toString();

        const educationsResponse = await lloFetch(`/api/competentNLEducation/Search?${requestConfig}`);

        if (!educationsResponse.ok) {
            return {
                status: educationsResponse.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const educationsData = await educationsResponse.json();

        return {
            status: educationsResponse.status,
            type: FetchResultType.Success,
            data: educationsData.data as EducationResource[],
        };
    } catch (error) {
        console.error('[getCompetentNLEducationsApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};

export const getCompetentNLEducationApiCall = async (id: string): Promise<FetchResult<EducationResource, string>> => {
    try {
        const educationResponse = await lloFetch(`/api/competentNLEducation/${id}`);

        if (!educationResponse.ok) {
            return {
                status: educationResponse.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const educationData = await educationResponse.json();

        return {
            status: educationResponse.status,
            type: FetchResultType.Success,
            data: educationData as EducationResource,
        };
    } catch (error) {
        console.error('[getCompetentNLEducationApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};
